// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.error-icon[data-v-6405afb8] {\r\n  position: absolute;\r\n  margin-left: 5px;\r\n  font-size: 18px;\r\n  color: #ff5b5c !important;\n}\n.txt-white[data-v-6405afb8] {\r\n  color: #fff !important;\n}\n.title-tab-wrapper[data-v-6405afb8] {\r\n  min-width: 20px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
